// /friends: your friends and their Daily Gig today, the people asking, and your link. The screen is web/friends-sheet.ts.
// Friends need an account, so signed out this is your account page, where the way in is.
import { $, ACCOUNT, pageHref, t } from '../web/common.ts';
import { SBACCT } from '../web/account.ts';
import { mountFriends } from '../web/friends-sheet.ts';
import { goOn, mountNav } from '../web/nav.ts';
import { keepFriendCount } from '../web/nav-friends.ts';

const A = SBACCT;
document.title = t('Friends') + ' · SongBuzz';
mountNav('friends'); keepFriendCount();
if (!A) location.replace(pageHref('/'));
else {
  // signed in here last time: the list at once (as it was last), and the server's when it answers
  let on = false;
  if (ACCOUNT.maybe()) { mountFriends($('#main')); on = true; }
  A.account().then((s) => { if (!s) goOn(pageHref('/account')); else if (!on) mountFriends($('#main')); }, () => goOn(pageHref('/account')));
}
